import Link from 'next/link';
import { useContext } from 'react';
import { useTranslation } from '../../lib/i18n';
import List from '../common/list';
import { Container } from '../layout/container';
import Layout from '../layout/layout';
import { WishlistContext } from './wishlist-context';

const Result = ({ category, results, className = 'mt-10' }) => {
  const { t } = useTranslation();
  return (
    <>
      {results ? (
        <div className={className}>
          <h2 className='mb-4 ml-8 text-base'>{t('search_' + category)}</h2>
          <List items={results} listName={'whishlist'} />
        </div>
      ) : (
        <> </>
      )}
    </>
  );
};

const Wishlist = () => {
  const { t } = useTranslation();
  const { getWishlistContents } = useContext(WishlistContext);
  const data = getWishlistContents();

  const count = Object.values(data).reduce((acc, v) => {
    return acc + v.count;
  }, 0);

  return (
    <Layout className='bg-green-gradient-1' robots='noindex'>
      <Container wide={true}>
        <h1 className='mt-10 text-center'>{t('wishList')}</h1>

        {count > 0 ? (
          <>
            <Result
              results={data.wines.swr.data?.results}
              category='wein'
              className=''
            />
            <Result results={data.packages.swr.data?.results} category='set' />
            <Result results={data.events.swr.data?.results} category='events' />
            <Result results={data.posts.swr.data?.results} category='blog' />
            <Result results={data.misc.swr.data?.results} category='allerlei' />
          </>
        ) : (
          <div className='text-center'>
            <p className='py-4 text-center'>
              {t('Deine Merkliste ist leer')}.{' '}
              <Link href='/wein' className='font-bold text-green'>
                {t('Zu den Weinen')}.
              </Link>
            </p>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default Wishlist;
